export default {
  methods: {
    resolvePlayerName(uid) {
      if (
        this.$store.state.players.byUid == null
        || this.$store.state.players.byUid[uid] == null
      ) {
        return null;
      }
      return this.$store.state.players.byUid[uid].username;
    },
  },
};
